import { render, staticRenderFns } from "./SCIM.vue?vue&type=template&id=5b2ac852&"
import script from "./SCIM.vue?vue&type=script&lang=ts&"
export * from "./SCIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports